var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLhb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8992 74.3992H9.69922V9.69922H19.2992V64.5992H51.8992V74.3992Z",
    fill: "#BFB401"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.701 9.69922V35.0992H78.4008V9.69922H68.8008V74.3992H78.4008V44.7992H108.701V74.3992H118.301V9.69922H108.701Z",
    fill: "#BFB401"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M118.399 94.5996H9.69922V118.3H118.399V94.5996Z",
    fill: "#BFB401"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLhb);
export default __webpack_public_path__ + "static/media/lhb - ธนาคารแลนด์ แอนด์ เฮ้าส์.9554bbc20afd4d45596820781c3d8975.svg";
export { ForwardRef as ReactComponent };